<template>
  <el-table
    :data="tableData"
    border
    class="transparent-table"
    style="width: 100%">
    <el-table-column
      fixed
      prop="date"
      label="设备编号"
      width="150">
    </el-table-column>
    <el-table-column
      prop="name"
      label="阀门状态"
      width="120">
    </el-table-column>
    <el-table-column
      prop="province"
      label="拆卸状态"
      width="120">
    </el-table-column>
    <el-table-column
      prop="city"
      label="漏水"
      width="120">
    </el-table-column>
    <el-table-column
      prop="address"
      label="流量超限"
      width="300">
    </el-table-column>
    <el-table-column
      fixed="right"
      label="操作"
      width="100">
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
        <el-button type="text" size="small">编辑</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    methods: {
      handleClick(row) {
        console.log(row);
      }
    },

    data() {
      return {
        tableData: [{
          date: '100000000000000',
          name: '阀开',
          province: '正常',
          city: '正常',
          address: '正常',
          zip: '正常'
        }, {
          date: '100000000000001',
          name: '阀开',
          province: '正常',
          city: '正常',
          address: '正常',
          zip: '正常'
        }, {
          date: '100000000000002',
          name: '阀开',
          province: '正常',
          city: '正常',
          address: '正常',
          zip: '正常'
        }, {
          date: '100000000000003',
          name: '无阀门',
          province: '正常',
          city: '正常',
          address: '正常',
          zip: '正常'
        }]
      }
    }
  }
</script>

<style>
.transparent-table,
.transparent-table .el-table__header-wrapper,
.transparent-table .el-table__body-wrapper,
.transparent-table .el-table__body,
.transparent-table .el-table__header,
.transparent-table .el-table__row,
.transparent-table th,
.transparent-table td,
.transparent-table .el-table__cell {
  background: #061326 !important;
  color: #fff !important;
}

/* 设置表格边框颜色 */
.transparent-table,
.transparent-table .el-table__cell,
.transparent-table .el-table__header,
.transparent-table .el-table__body,
.transparent-table .el-table__row,
.transparent-table th,
.transparent-table td {
  border-color: #050926 !important;
  line-height: 28px !important; /* 可根据需要调整为更小的数值 */
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.transparent-table {
  border-radius: 12px; /* 圆角大小可调整 */
  overflow: hidden;    /* 防止内容溢出圆角 */
}

/* 如果需要让表头和表体也跟随圆角，可加 */
.transparent-table .el-table__header-wrapper,
.transparent-table .el-table__body-wrapper {
  border-radius: 12px;
}
</style>